export const FLIGHTS_SEARCHES_LOCAL_STORAGE_KEY = 'previous-search-data';
export const HOTELS_SEARCHES_LOCAL_STORAGE_KEY =
  'accommodation-recent-searches';
export const FLIGHTS_SEARCH_SESSION_STORAGE_KEY =
  'search-extension-flight-search';
export const HSA_FLIGHT_SUMMARY_SESSION_STORAGE_KEY = 'hsaFlightSummaryData';
